import { SAVED_VIEW_KEY } from './constants';

export const addSavedViewKeyToSessionStorage = (): void => {
  // check if it is copy link view and save it in session storage will be removed after restoring the view
  const urlParams = new URLSearchParams(window.location.search);
  const viewKey = urlParams.get('view');
  if (viewKey) {
    window.sessionStorage.setItem(SAVED_VIEW_KEY, viewKey);
  }
};
